 var $slider = $('.order-slider');

  $slider.slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    variableWidth: false,
    centerPadding: "0px",
    infinite: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          variableWidth: false,
          centerPadding: "0px",
  adaptiveHeight: false, // Adjusts height dynamically
          prevArrow: '<button type="button" class="custom-prev"><svg xmlns="http://www.w3.org/2000/svg" fill="#000000" height="20px" width="20px" viewBox="0 0 330 330"><path d="M111.213,165.004L250.607,25.607c5.858-5.858,5.858-15.355,0-21.213c-5.858-5.858-15.355-5.858-21.213,0.001l-150,150.004C76.58,157.211,75,161.026,75,165.004c0,3.979,1.581,7.794,4.394,10.607l150,149.996C232.322,328.536,236.161,330,240,330s7.678-1.464,10.607-4.394c5.858-5.858,5.858-15.355,0-21.213L111.213,165.004z"></path></svg></button>',
          nextArrow: '<button type="button" class="custom-next"><svg xmlns="http://www.w3.org/2000/svg" fill="#000000" height="20px" width="20px" viewBox="0 0 330 330"><path d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606C255,161.018,253.42,157.202,250.606,154.389z"></path></svg></button>',
          arrows: true
        }
      },
      {
        breakpoint: 360,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerPadding: "0px",
          variableWidth: false,
  adaptiveHeight: true, // Adjusts height dynamically
          prevArrow: '<button type="button" class="custom-prev"><svg xmlns="http://www.w3.org/2000/svg" fill="#000000" height="20px" width="20px" viewBox="0 0 330 330"><path d="M111.213,165.004L250.607,25.607c5.858-5.858,5.858-15.355,0-21.213c-5.858-5.858-15.355-5.858-21.213,0.001l-150,150.004C76.58,157.211,75,161.026,75,165.004c0,3.979,1.581,7.794,4.394,10.607l150,149.996C232.322,328.536,236.161,330,240,330s7.678-1.464,10.607-4.394c5.858-5.858,5.858-15.355,0-21.213L111.213,165.004z"></path></svg></button>',
          nextArrow: '<button type="button" class="custom-next"><svg xmlns="http://www.w3.org/2000/svg" fill="#000000" height="20px" width="20px" viewBox="0 0 330 330"><path d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606C255,161.018,253.42,157.202,250.606,154.389z"></path></svg></button>',
          arrows: true
        }
      }
    ]
  });




$(document).ready(function () {
   
   jQuery(".subscribe-container_p").find(".subscription-container_o .subscription-left .subscription-options input").each(function(){
     jQuery(this).prop("checked", false);
   });

  
  setTimeout(function(){
    jQuery(".subscribe-container_p").each(function(){
      let fragrance_description = jQuery(this).find(".variant-selector-product option:selected").attr("data-fragrance-desc");
      console.log("Hello: ", jQuery(this).find(".variant-selector-product option:selected"));
      jQuery(this).siblings(".description").find("#selected-product-title").html(fragrance_description);
    });
  }, 500);
  

  
    jQuery(".fragrance-options select").each(function(){
     console.log(jQuery(this));
     jQuery(this).html(jQuery(this).closest(".subscribe-container_p").find("product-selector select[name='options[Fragrance]']").html());
   });
  

     jQuery(".fragrance-options select").on("change", function(e){
        const targetPosition = jQuery(this).closest(".candle-box").find(".product-media-wrapper").offset().top; // get target position
    
        $('html, body').animate({
          scrollTop: targetPosition - 100
        }, 800); // 800ms animation duration

       let selected_option = jQuery(this).val();
       let selected_option_id = jQuery(this).find("option:checked").attr("data-variant-id");
       let selected_option_image = jQuery(this).find("option:checked").attr("data-image"); // Get data-image
       let fragrance_description = jQuery(this).find("option:checked").attr("data-fragrance-desc");
       console.log("selected_option_id: ", selected_option_id);

       let select_variant_price = parseInt(jQuery(this).find("option:checked").attr("data-price").replace(/\D/g, ''));
       jQuery(this).closest(".box-inner").find(".price-candle").attr("data-price", select_variant_price);
       jQuery(this).closest(".box-inner").find(".price-candle").text("$" + select_variant_price.toFixed(2));
       jQuery(this).closest(".subscription-container_o").find("input[type='radio']:checked").trigger("change");
       
       jQuery(this).closest(".subscribe-container_p").find("product-selector select[name='options[Fragrance]']").val(selected_option);
       e.target.closest(".subscribe-container_p").querySelector("product-selector select[name='options[Fragrance]").dispatchEvent(new Event('change'));
        jQuery(this).closest(".subscribe-container_p").find("[name='id']").val(selected_option_id);
       jQuery(this).find("#product-image-2").attr("src", selected_option_image);
       // e.target.closest(".subscribe-container_p").querySelector("product-selector select[name='options[Fragrance]']").change();
       
       jQuery(this).closest(".subscribe-container_p").siblings(".description").find("#selected-product-title").html(fragrance_description);
        let images = jQuery(this).closest(".box-inner").siblings(".product-media-wrapper").children("img");
        images.each(function() {
    // Check if the image has a matching attribute, for example, data-variant-id
    if (jQuery(this).attr("data-variant-id") === selected_option_id) {
        // Perform the action, e.g., show this image or perform some manipulation
        jQuery(this).show();  // Example: Show the matching image
    } else {
        // Optionally, hide other images that don't match
        jQuery(this).hide();
    }
});
     });


    setTimeout(function(){
      if(jQuery(".subscription-label").length > 0) {
        jQuery(".subscription-label").each(function(index, el){
            if(index == 0 || index == 2) {
                jQuery(this).find("input").prop('checked', true);
            }
        });
      }
    }, 500);
    
    

    jQuery(".subscription-label input").on("change", function(){
      let selected_index = jQuery(this).attr("data-index");
      let selected_percentage_off = parseInt(jQuery(this).attr("data-price-off"));
      let regular_price = parseInt(jQuery(this).closest(".box-inner").find(".price-candle").attr("data-price").replace(/\D/g, ''));
      // console.log("Selected off: ", selected_percentage_off);
      // console.log("regular_price: ", regular_price);
      let calculated_price = regular_price - ((regular_price * selected_percentage_off) / 100);
      console.log("calculated_price: ", calculated_price);
      jQuery(this).closest(".box-inner").find(".subscription-price-candle").text("$" + calculated_price.toFixed(2));
      jQuery(this).closest(".box-inner").find(".subscription-price-candle").removeClass("hide");
      jQuery(this).closest(".box-inner").find(".price-candle").addClass("strike");
      // jQuery(this).closest(".subscribe-container_p").find(".main-product__purchase-option-values .main-product__purchase-option-values-item.radio:nth-child("+selected_index+") input").prop('checked', true);
      jQuery(this).closest(".subscribe-container_p").find(".main-product__purchase-option-values .main-product__purchase-option-values-item.radio:nth-child("+selected_index+") label").click();
    });

    jQuery(".subscribe-btn").on("click", function(e) {
      let name = jQuery(this).closest(".subscribe-container_p").find(".subscription-container_o .subscription-left .subscription-options:nth-of-type(1) input").attr("name");
      if(jQuery("input[name='"+name+"']").is(':checked')) {
        jQuery(this).closest(".subscribe-container_p").find(".main-product__form-buttons button").trigger("click");
        jQuery(this).attr("disabled", "disabled");
        jQuery(this).text("Adding to cart...");
      }
    });
    

   $('.candles-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: $('.prev-arrow'),
    nextArrow: $('.next-arrow'),
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3 }
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1 }
      }
    ]
  });


  function checkDropdownItems() {
    document.querySelectorAll(".dropdown-item").forEach(function (dropdown) {
        let title = dropdown.querySelector(".dropdown-title");
        let content = dropdown.querySelector(".dropdown-content-faq");
        let icon = dropdown.querySelector(".dropdown-icon");
        let header = dropdown.querySelector(".dropdown-header");

        // Check if both title and content are empty
        if ((!title || title.innerText.trim() === "") && (!content || content.innerText.trim() === "")) {
            if (icon) icon.style.display = "none"; // Hide the icon
            if (header) header.style.padding = "35px"; // Add extra padding
        } else {
            if (icon) icon.style.display = "inline-block"; // Show the icon if content exists
            if (header) header.style.padding = ""; // Reset padding
        }
    });
}

// Function to ensure the script runs on AJAX-loaded pages
function initDropdownObserver() {
    checkDropdownItems(); // Run initially

    const observer = new MutationObserver(function () {
        checkDropdownItems();
    });

    document.querySelectorAll(".dropdown-item").forEach(function (dropdown) {
        observer.observe(dropdown, { childList: true, subtree: true, characterData: true });
    });
}

// Run script on first page load
document.addEventListener("DOMContentLoaded", initDropdownObserver);

// Shopify AJAX page load support
document.addEventListener("shopify:section:load", initDropdownObserver);
document.addEventListener("shopify:section:reorder", initDropdownObserver);
document.addEventListener("shopify:section:unload", initDropdownObserver);
document.addEventListener("shopify:section:select", initDropdownObserver);
document.addEventListener("shopify:section:deselect", initDropdownObserver);
document.addEventListener("shopify:section:block:select", initDropdownObserver);
document.addEventListener("shopify:section:block:deselect", initDropdownObserver);





  $(".dropdown-header").click(function() {
    const item = $(this).parent();
    const icon = $(this).find(".dropdown-icon");

    item.toggleClass("active");

    // Define SVGs for + and -
    const plusSVG = `<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11 7V15M7 11H15M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

    const minusSVG = `<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7 11H15M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

    // Toggle SVG icon
    if (item.hasClass("active")) {
        icon.html(minusSVG).css("transform", "rotate(0deg)");
    } else {
        icon.html(plusSVG).css("transform", "rotate(0deg)");
    }
});

$(window).on('load resize', function() {
    if ($(window).width() < 940) {
        $('.subscribe-slider').slick('slickSetOption', 'slidesToShow', 1, true);
    }
});

  $('.subscribe-slider').on('breakpoint', function(event, slick, breakpoint) {
  /*  console.log('Breakpoint hit:', breakpoint);*/
});


  $('.subscribe-slider').slick({
    slidesToShow: 1,  // Show only 2 slides at a time
    slidesToScroll: 1,
    centerMode: true, // Enable centering
    centerPadding: '0px', // Adjust if needed (e.g., '50px' for spacing)
    autoplay: false,
    dots: false,
    arrows: true,
    prevArrow: '<button type="button" class="custom-prev"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" height="30px" width="30px" version="1.1" id="Layer_1" viewBox="0 0 330 330" xml:space="preserve"> <path id="XMLID_92_" d="M111.213,165.004L250.607,25.607c5.858-5.858,5.858-15.355,0-21.213c-5.858-5.858-15.355-5.858-21.213,0.001  l-150,150.004C76.58,157.211,75,161.026,75,165.004c0,3.979,1.581,7.794,4.394,10.607l150,149.996  C232.322,328.536,236.161,330,240,330s7.678-1.464,10.607-4.394c5.858-5.858,5.858-15.355,0-21.213L111.213,165.004z"></path> </svg></button>',
    nextArrow: '<button type="button" class="custom-next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" height="30px" width="30px" version="1.1" id="Layer_1" viewBox="0 0 330 330" xml:space="preserve"> <path id="XMLID_222_" d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001  c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213  C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606  C255,161.018,253.42,157.202,250.606,154.389z"></path> </svg></button>',
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 1,
                centerMode: true
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1, // Adjust if needed for mobile
                centerMode: true
            }
        }
    ]
});

  
   setTimeout(function() {
        $('.subscribe-slider').slick('refresh');
    }, 500);


  


        // Ensure popup is hidden on page load
    $(".unique-popup-overlay").hide();

    // Show popup on clicking "More Info"
    $(".unique-more-info").click(function (event) {
        event.preventDefault(); // Prevent default link behavior
        $(".unique-popup-overlay").fadeIn();
    });

    // Close popup when clicking the close button
    $(".unique-popup-close").click(function () {
        $(".unique-popup-overlay").fadeOut();
    });

    // Close popup when clicking outside the content
    $(document).click(function (event) {
        if ($(event.target).closest(".unique-popup-content, .unique-more-info").length === 0) {
            $(".unique-popup-overlay").fadeOut();
        }
    });

  

});